import React, { useContext, useEffect, useState, useRef } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";

import Account_Created_Modal from "../account-created-modal/Account_Created_Modal";
import Common_Login_Button from "../../../common_components/common-login-button/Common_Login_Button";
import "./Vendor_Login.css";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../../../utils/IDS";
import { Controller, useForm } from "react-hook-form";
import {
  AllState,
  AllDistrict,
  AllCartegory,
  AllAppSetup,
  AllSubServiceCategories,
} from "../../../../features/admin/common/Slice";
import {
  verifyOtp,
  CreateVendor1Signup,
  CreateVendor2Signup,
  CreateVendor3Signup,
  sendMobileOtp,
  sendLoginOtp,
  LoginverifyOtp,
  GETVendor,
  addharVerifyOtp,
  addharSendOtp,
} from "../../../../features/admin/auth/Slice";
import classNames from "classnames";
import { Context } from "../../../../utils/context";
import Cookies from "js-cookie";

const Vendor_Login = ({ activeTab }) => {
  const dispatch = useDispatch();
  const userType = IDS.USER_TYPES[activeTab?.toUpperCase()];
  const { setSignin, isTokenValid, deviceKey } = useContext(Context);
  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { discount: 1, lat: "", long: "" },
  });

  const mapRef = useRef();
  const mapInstance = useRef(null);
  const markerRef = useRef(null);
  const searchInputRef = useRef();

  const selectedState = watch("state_id");
  const loginMobile = watch("login_mobile");
  const watchMobile = watch("mobile_number");
  const licenImageFile = watch("licen_image");
  const shopImageFile = watch("shop_image");
  const shopImage2File = watch("shop_image2");
  const watchEmail = watch("email");
  const selectedCategories = watch("category_id");

  const states = useSelector((state) => state?.common?.all_state);
  const districts = useSelector((state) => state?.common?.all_district);
  const categories = useSelector((state) => state?.common?.all_category);
  const subServiceCategories = useSelector(
    (state) => state?.common?.all_sub_service_categories,
  );
  const all_app_setup = useSelector((state) => state?.common?.all_app_setup);

  const [isRegistering, setIsRegistering] = useState(false);
  const [formStep, setFormStep] = useState("register-step-1");
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [vendorId, setVendorId] = useState(null);

  const [loading, setLoading] = useState({
    sendLoginOtp: false,
    verifyLoginOtp: false,
    sendRegisterOtp: false,
    verifyRegisterOtp: false,
    login: false,
    register: false,
  });

  // ====================== LOGIN OTP STATES ======================
  const [isOtpSentLogin, setIsOtpSentLogin] = useState(false);
  const [isOtpVerifiedLogin, setIsOtpVerifiedLogin] = useState(false);
  const [loginOtp, setLoginOtp] = useState(["", "", "", "", "", ""]);
  const [loginOtpError, setLoginOtpError] = useState("");
  const [loginMobileError, setLoginMobileError] = useState("");
  const [timerLogin, setTimerLogin] = useState(60);
  const [isOtpExpiredLogin, setIsOtpExpiredLogin] = useState(false);

  // ====================== REGISTRATION OTP STATES ======================
  const [isOtpSentRegister, setIsOtpSentRegister] = useState(false);
  const [isOtpVerifiedRegister, setIsOtpVerifiedRegister] = useState(false);
  const [registerOtp, setRegisterOtp] = useState(["", "", "", "", "", ""]);
  const [registerOtpError, setRegisterOtpError] = useState("");
  const [mobileOtpErrorRegister, setMobileOtpErrorRegister] = useState("");
  const [timerRegister, setTimerRegister] = useState(60);
  const [isOtpExpiredRegister, setIsOtpExpiredRegister] = useState(false);

  const [isAadharOtpSent, setIsAadharOtpSent] = useState(false);
  const [isAadharOtpVerified, setIsAadharOtpVerified] = useState(false);
  const [aadharOtp, setAadharOtp] = useState(["", "", "", "", "", ""]);
  const [aadharOtpError, setAadharOtpError] = useState("");
  const [aadharOtpTimer, setAadharOtpTimer] = useState(600); // 10 minutes
  const [isAadharOtpExpired, setIsAadharOtpExpired] = useState(false);
  const [loadingAadharSendOtp, setLoadingAadharSendOtp] = useState(false);
  const [loadingAadharVerifyOtp, setLoadingAadharVerifyOtp] = useState(false);
  const [isAadharLocked, setIsAadharLocked] = useState(false);

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "45px",
      borderRadius: "30px",
      border: "1px solid #ddd",
      boxShadow: "none",
      "&:hover": { border: "1px solid #aaa" },
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({ ...base, padding: "0 20px" }),
  };

  const catSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "45px",
      borderRadius: "30px",
      border: "1px solid #ddd",
      paddingTop: "15px",
      boxShadow: "none",
      "&:hover": { border: "1px solid #aaa" },
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({ ...base, padding: "0 20px" }),
  };

  // ====================== Map Logic ======================
  // useEffect(() => {
  //   if (isRegistering) loadMap();
  // }, [isRegistering]);
  useEffect(() => {
    if (!isRegistering) return;

    const timer = setTimeout(() => {
      if (window.google?.maps && mapRef.current) {
        initMap();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [isRegistering]);

  const loadMap = () => {
    if (window.google?.maps) {
      initMap();
      setTimeout(initAutocomplete, 500);
    } else {
      const interval = setInterval(() => {
        if (window.google?.maps) {
          clearInterval(interval);
          initMap();
          setTimeout(initAutocomplete, 500);
        }
      }, 100);
    }
  };

  const loadMapWithPosition = (position) => {
    mapInstance.current = new window.google.maps.Map(mapRef.current, {
      center: position,
      zoom: 15,
    });
    markerRef.current = new window.google.maps.Marker({
      position,
      map: mapInstance.current,
      draggable: true,
    });

    setValue("lat", position.lat.toString());
    setValue("long", position.lng.toString());

    mapInstance.current.addListener("click", (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      setValue("lat", lat.toString());
      setValue("long", lng.toString());
      markerRef.current.setPosition({ lat, lng });
    });

    markerRef.current.addListener("dragend", (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      setValue("lat", lat.toString());
      setValue("long", lng.toString());
    });
  };

  const initMap = () => {
    const fallback = { lat: 18.5204, lng: 73.8567 };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const currentPos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          loadMapWithPosition(currentPos);
          initAutocomplete();
        },
        (error) => {
          console.log("Location error:", error);

          loadMapWithPosition(fallback);
          initAutocomplete();
        },
      );
    } else {
      loadMapWithPosition(fallback);
      initAutocomplete();
    }
  };

  const initAutocomplete = () => {
    if (!searchInputRef.current || !window.google?.maps?.places) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInputRef.current,
      {
        types: ["geocode"], // restrict to addresses
        componentRestrictions: { country: "in" }, // optional
      },
    );

    autocomplete.bindTo("bounds", mapInstance.current);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.geometry?.location) return;

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      mapInstance.current.setCenter({ lat, lng });
      mapInstance.current.setZoom(15);
      markerRef.current.setPosition({ lat, lng });
      setValue("lat", lat.toString());
      setValue("long", lng.toString());
      searchInputRef.current.value = place.formatted_address;
    });
  };

  // ====================== OTP Handlers ======================
  const handleOtpChange = (value, index, isLogin) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = isLogin ? [...loginOtp] : [...registerOtp];
    newOtp[index] = value;

    if (isLogin) {
      setLoginOtp(newOtp);
      setLoginOtpError(""); // 👈 ADD THIS
    } else {
      setRegisterOtp(newOtp);
      setRegisterOtpError(""); // 👈 ADD THIS
    }

    if (value && index < 5) {
      const id = `otp-${isLogin ? "login" : "register"}-${index + 1}`;
      document.getElementById(id)?.focus();
    }
  };

  const handleOtpKeyDown = (e, index, isLogin) => {
    if (e.key === "Backspace") {
      const newOtp = isLogin ? [...loginOtp] : [...registerOtp];
      if (newOtp[index]) newOtp[index] = "";
      else if (index > 0) {
        newOtp[index - 1] = "";
        const prevId = `otp-${isLogin ? "login" : "register"}-${index - 1}`;
        document.getElementById(prevId)?.focus();
      }
      if (isLogin) setLoginOtp(newOtp);
      else setRegisterOtp(newOtp);
    }
  };

  const handleSendLoginOtp = async () => {
    const mobile = getValues("login_mobile");

    // ✅ VALIDATION FIRST
    if (!mobile || mobile.length !== 10) {
      setLoginMobileError("Please enter valid 10 digit mobile number");
      return; // ❌ STOP here → NO loader
    }

    setLoginMobileError("");
    setLoginOtpError("");

    // ✅ THEN LOADER
    setLoading((prev) => ({ ...prev, sendLoginOtp: true }));

    try {
      const res = await dispatch(
        sendLoginOtp({
          mobile_number: mobile,
          type: userType,
        }),
      ).unwrap();

      if (res?.success) {
        setIsOtpSentLogin(true);
        setLoginOtp(["", "", "", "", "", ""]);
        setTimerLogin(60);
        setIsOtpExpiredLogin(false);
      }
    } catch (err) {
      setLoginMobileError(err?.message || "Something went wrong");
    } finally {
      setLoading((prev) => ({ ...prev, sendLoginOtp: false }));
    }
  };

  const handleLoginVerifyOtp = async () => {
    const enteredOtp = loginOtp.join("");

    // ✅ VALIDATION FIRST
    if (!enteredOtp || enteredOtp.length !== 6) {
      setLoginOtpError("Please enter 6 digit OTP");
      return; // ❌ STOP → no loader
    }

    if (isOtpExpiredLogin) {
      setLoginOtpError("OTP expired. Please resend.");
      return;
    }

    setLoginOtpError("");

    // ✅ LOADER AFTER VALIDATION
    setLoading((prev) => ({ ...prev, verifyLoginOtp: true }));

    try {
      const res = await dispatch(
        LoginverifyOtp({
          mobile_number: getValues("login_mobile"),
          otp: enteredOtp,
          type: userType,
          device_key: deviceKey || "",
        }),
      ).unwrap();

      if (res?.success) {
        setIsOtpVerifiedLogin(true);
      }
    } catch (err) {
      setLoginOtpError(err?.message || "Invalid OTP");
    } finally {
      setLoading((prev) => ({ ...prev, verifyLoginOtp: false }));
    }
  };

  // ====================== Register OTP ======================
  const handleSendRegisterOtp = async () => {
    setMobileOtpErrorRegister("");
    setLoading((prev) => ({ ...prev, sendRegisterOtp: true }));
    try {
      const res = await dispatch(
        sendMobileOtp({
          mobile_number: getValues("mobile_number"),
          type: userType,
        }),
      );

      if (res?.meta?.requestStatus === "fulfilled") {
        setIsOtpSentRegister(true);
        setIsOtpVerifiedRegister(false);
        setRegisterOtp(["", "", "", "", "", ""]);
        setTimerRegister(60);
        setIsOtpExpiredRegister(false);
        setRegisterOtpError("");
      } else {
        setMobileOtpErrorRegister(
          res?.payload?.message || "Failed to send OTP",
        );
      }
    } catch (err) {
      setMobileOtpErrorRegister("Something went wrong");
    } finally {
      setLoading((prev) => ({ ...prev, sendRegisterOtp: false }));
    }
  };

  const handleVerifyRegisterOtp = async () => {
    const enteredOtp = registerOtp.join("");
    if (enteredOtp.length !== 6) {
      setRegisterOtpError("Please enter 6 digit OTP");
      return;
    }

    setLoading((prev) => ({ ...prev, verifyRegisterOtp: true }));

    try {
      const res = await dispatch(
        verifyOtp({
          mobile_number: getValues("mobile_number"),
          otp: enteredOtp,
          type: userType,
        }),
      );

      if (res?.meta?.requestStatus === "fulfilled" && res?.payload?.success) {
        setIsOtpVerifiedRegister(true);
        setRegisterOtpError("");
      } else {
        setRegisterOtpError(res?.payload?.message || "Invalid OTP");
      }
    } catch (err) {
      setRegisterOtpError("Something went wrong");
    } finally {
      setLoading((prev) => ({ ...prev, verifyRegisterOtp: false }));
    }
  };

  // const handleSendAadharOtp = async () => {
  //   const aadharNo = getValues("adhar_no");

  //   if (!aadharNo || aadharNo.length !== 12) {
  //     setAadharOtpError("Enter valid 12 digit Aadhaar Number");
  //     return;
  //   }

  //   setLoadingAadharSendOtp(true);
  //   setAadharOtpError("");

  //   try {
  //     const res = await dispatch(
  //       addharSendOtp({
  //         aadhaar_number: aadharNo,
  //       }),
  //     );
  //     if (res?.payload?.success) {
  //       const newReqId = res?.payload?.data?.response?.ref_id;

  //       if (newReqId) {
  //         Cookies.set("aadhaar_ref_id", newReqId, { expires: 1 });
  //         console.log("New Req ID:", newReqId);
  //       }

  //       setIsAadharOtpSent(true);
  //       setIsAadharOtpVerified(false);
  //       setAadharOtp(["", "", "", "", "", ""]);
  //       setAadharOtpTimer(120);
  //       setIsAadharOtpExpired(false);
  //       setIsAadharLocked(true);
  //     } else {
  //       let errorMessage = "Failed to send Aadhaar OTP";

  //       if (typeof res?.payload?.message === "string") {
  //         errorMessage = res.payload.message;
  //       } else if (
  //         typeof res?.payload?.message === "object" &&
  //         res?.payload?.message?.aadhaar_number?.length
  //       ) {
  //         errorMessage = res.payload.message.aadhaar_number[0];
  //       } else if (res?.payload?.data?.msg) {
  //         errorMessage = res.payload.data.msg;
  //       }

  //       setAadharOtpError(errorMessage);
  //     }
  //   } catch (error) {
  //     setAadharOtpError("Something went wrong");
  //   } finally {
  //     setLoadingAadharSendOtp(false);
  //   }
  // };

  //below code was after client changes for showing the please try after some time showing error  and above code was showing all the error when success false
  const handleSendAadharOtp = async () => {
    const aadharNo = getValues("adhar_no");

    if (!aadharNo || aadharNo.length !== 12) {
      setAadharOtpError("Enter valid 12 digit Aadhaar Number");
      return;
    }

    setLoadingAadharSendOtp(true);
    setAadharOtpError("");

    try {
      const res = await dispatch(
        addharSendOtp({
          aadhaar_number: aadharNo,
        }),
      );

      if (res?.payload?.success) {
        const newReqId = res?.payload?.data?.response?.ref_id;

        if (newReqId) {
          Cookies.set("aadhaar_ref_id", newReqId, { expires: 1 });
        }

        setIsAadharOtpSent(true);
        setIsAadharOtpVerified(false);
        setAadharOtp(["", "", "", "", "", ""]);
        setAadharOtpTimer(600); // 10 minutes
        setIsAadharOtpExpired(false);
        setIsAadharLocked(true);
      } else {
        setAadharOtpError("Please try after sometime");
      }
    } catch (error) {
      setAadharOtpError("Please try after sometime");
    } finally {
      setLoadingAadharSendOtp(false);
    }
  };

  const handleVerifyAadharOtp = async () => {
    const enteredOtp = aadharOtp.join("");

    if (enteredOtp.length !== 6) {
      setAadharOtpError("Please enter 6 digit OTP");
      return;
    }

    const refId = Cookies.get("aadhaar_ref_id");

    setLoadingAadharVerifyOtp(true);

    try {
      const res = await dispatch(
        addharVerifyOtp({
          aadhaar_number: getValues("adhar_no"),
          otp: enteredOtp,
          req_id: refId,
        }),
      );

      if (res?.payload?.success) {
        setIsAadharOtpVerified(true);
        setAadharOtpError("");

        Cookies.remove("aadhaar_ref_id");
      } else {
        let errorMessage = "Invalid OTP";

        if (typeof res?.payload?.message === "string") {
          errorMessage = res.payload.message;
        } else if (typeof res?.payload?.message === "object") {
          const messageObj = res.payload.message;

          if (messageObj.req_id?.length) {
            errorMessage = messageObj.req_id[0];
          } else if (messageObj.otp?.length) {
            errorMessage = messageObj.otp[0];
          } else if (messageObj.aadhaar_number?.length) {
            errorMessage = messageObj.aadhaar_number[0];
          } else {
            errorMessage = Object.values(messageObj).flat()[0];
          }
        } else if (typeof res?.payload?.data === "string") {
          errorMessage = res.payload.data;
        }

        setAadharOtpError(errorMessage);
      }
    } catch (error) {
      setAadharOtpError(
        error?.response?.data?.message || "Something went wrong",
      );
    } finally {
      setLoadingAadharVerifyOtp(false);
    }
  };

  useEffect(() => {
    let interval;

    if (isAadharOtpSent && !isAadharOtpVerified && aadharOtpTimer > 0) {
      interval = setInterval(() => {
        setAadharOtpTimer((prev) => prev - 1);
      }, 1000);
    }

    if (aadharOtpTimer === 0 && isAadharOtpSent && !isAadharOtpVerified) {
      setIsAadharOtpExpired(true);
    }

    return () => clearInterval(interval);
  }, [isAadharOtpSent, isAadharOtpVerified, aadharOtpTimer]);

  const handleAadharOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...aadharOtp];
    newOtp[index] = value;

    setAadharOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-aadhar-${index + 1}`)?.focus();
    }
  };

  const handleAadharOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !aadharOtp[index] && index > 0) {
      document.getElementById(`otp-aadhar-${index - 1}`)?.focus();
    }
  };

  useEffect(() => {
    if (selectedCategories?.length > 0) {
      const categoryIds = selectedCategories.map((item) => item.value);

      dispatch(
        AllSubServiceCategories({
          service_category_id: categoryIds,
        }),
      );
    } else {
      setValue("service_category_id", []);
    }
  }, [selectedCategories, dispatch, setValue]);

  // ====================== Main Submit (Login happens here) ======================
  const onSubmit = async (data) => {
    if (!isRegistering) {
      // ✅ MOBILE VALIDATION
      if (!data.login_mobile || data.login_mobile.length !== 10) {
        setLoginMobileError("Please enter valid mobile number");
        return;
      }

      // ✅ OTP SENT CHECK
      if (!isOtpSentLogin) {
        setLoginOtpError("Please send OTP first");
        return;
      }

      // ✅ OTP VERIFY CHECK
      if (!isOtpVerifiedLogin) {
        setLoginOtpError("Please verify OTP first");
        return;
      }

      // ✅ NOW START LOADER
      setLoading((prev) => ({ ...prev, login: true }));

      try {
        setSignin(true);
        await isTokenValid();
        dispatch(GETVendor({ type: "profile" }));
        navigate("/vendor-login-details");
      } catch (err) {
        console.error("Login failed", err);
      } finally {
        setLoading((prev) => ({ ...prev, login: false }));
      }

      return;
    }

    // REGISTRATION FLOW
    if (!isOtpVerifiedRegister) {
      alert("Please verify OTP before registering");
      return;
    }

    if (!isAadharOtpVerified) {
      setAadharOtpError("Please verify Aadhaar OTP first");
      return;
    }

    setLoading((prev) => ({ ...prev, register: true }));

    try {
      const step1Payload = {
        name: data.name,
        mobile_number: data.mobile_number,
        email: data.email,
        adhar_no: data.adhar_no,
        state_id: data.state_id.value,
        district_id: data.district_id.value,
        lat: data.lat,
        long: data.long,
        user_type: userType,
        device_key: deviceKey || "",
      };

      const step1Res = await dispatch(
        CreateVendor1Signup(step1Payload),
      ).unwrap();
      const createdVendorId = step1Res?.data?.user?.id;
      setVendorId(createdVendorId);

      const step2FormData = new FormData();
      step2FormData.append("id", createdVendorId);
      step2FormData.append("shop_name", data.shop_name);
      step2FormData.append("description", data.description);
      step2FormData.append("discount", data.discount);

      data.category_id?.forEach((cat) =>
        step2FormData.append("category_id[]", cat.value),
      );

      if (data.service_category_id?.length > 0) {
        data.service_category_id.forEach((subCat) => {
          step2FormData.append("sub_category_id[]", subCat.value);
        });
      }

      if (data.licen_image?.[0])
        step2FormData.append("licen_image", data.licen_image[0]);
      if (data.shop_image?.[0])
        step2FormData.append("shop_image", data.shop_image[0]);
      if (data.shop_image2?.[0])
        step2FormData.append("shop_image2", data.shop_image2[0]);

      await dispatch(CreateVendor2Signup(step2FormData)).unwrap();

      await dispatch(
        CreateVendor3Signup({
          id: createdVendorId,
          receive_document: data.receive_document ? 1 : 0,
          credit_udhar: 0,
        }),
      ).unwrap();

      setModalText("Account Created Successfully!");
      setShowAccountModal(true);

      setTimeout(() => {
        setShowAccountModal(false);
        setIsRegistering(false);
        setFormStep("register-step-1");
        reset();
        setRegisterOtp(["", "", "", "", "", ""]);
        setIsOtpSentRegister(false);
        setIsOtpVerifiedRegister(false);
        setIsOtpExpiredRegister(false);
        setVendorId(null);
      }, 2000);
    } catch (err) {
      console.error("Vendor registration failed", err);
      alert("Registration failed. Please try again.");
    } finally {
      setLoading((prev) => ({ ...prev, register: false }));
    }
  };

  // ====================== Timers ======================
  useEffect(() => {
    let interval = null;
    if (isOtpSentLogin && timerLogin > 0) {
      interval = setInterval(() => setTimerLogin((p) => p - 1), 1000);
    }
    if (timerLogin === 0 && isOtpSentLogin) setIsOtpExpiredLogin(true);
    return () => clearInterval(interval);
  }, [isOtpSentLogin, timerLogin]);

  useEffect(() => {
    let interval = null;
    if (isOtpSentRegister && timerRegister > 0) {
      interval = setInterval(() => setTimerRegister((p) => p - 1), 1000);
    }
    if (timerRegister === 0 && isOtpSentRegister) setIsOtpExpiredRegister(true);
    return () => clearInterval(interval);
  }, [isOtpSentRegister, timerRegister]);

  // Load initial data
  useEffect(() => {
    dispatch(AllState());
    dispatch(AllDistrict());
    dispatch(AllCartegory());
    dispatch(AllAppSetup());
  }, [dispatch]);

  useEffect(() => {
    if (selectedState?.value) {
      dispatch(AllDistrict({ state_id: selectedState.value }));
    } else {
      setValue("district_id", null);
    }
  }, [selectedState, dispatch, setValue]);

  const handleViewMou = () => {
    if (all_app_setup?.mou_pdf) {
      window.open(`${IDS.IMG_URL}${all_app_setup.mou_pdf}`, "_blank");
    }
  };

  useEffect(() => {
    if (loginMobile) {
      setLoginMobileError("");
    }
  }, [loginMobile]);

  useEffect(() => {
    if (loginOtp.some((digit) => digit !== "")) {
      setLoginOtpError("");
    }
  }, [loginOtp]);

  useEffect(() => {
    if (watchMobile) {
      setMobileOtpErrorRegister("");
    }
  }, [watchMobile]);

  useEffect(() => {
    if (registerOtp.some((digit) => digit !== "")) {
      setRegisterOtpError("");
    }
  }, [registerOtp]);

  const formatTimer = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  return (
    <div className="customer-card-container">
      <Form className="customer-form-body" onSubmit={handleSubmit(onSubmit)}>
        <div className="customer-header-row">
          <div className="customer-title-stack">
            <span className="customer-main-title">
              {isRegistering ? "Register as" : "Login as"} {activeTab}
            </span>
            <p className="customer-subtitle">to Nova Prime</p>
          </div>
          <img
            src="/assets/header/nova-prime-logo.png"
            alt="Logo"
            className="customer-brand-logo"
          />
        </div>

        {/* ====================== LOGIN SECTION ====================== */}
        {!isRegistering ? (
          <div className="login-fields-container">
            <div className="customer-input-group">
              <div className="phone-wrapper">
                <span className="country-code">+91</span>
                <Form.Control
                  type="tel"
                  placeholder=" "
                  maxLength={10}
                  disabled={isOtpSentLogin && !isOtpVerifiedLogin}
                  {...register("login_mobile", {
                    required: "Mobile number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Enter valid 10 digit mobile number",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                    setLoginMobileError(""); // 👈 add this
                  }}
                  className={classNames("phone-input", {
                    "is-invalid": errors?.login_mobile,
                  })}
                />
              </div>
              <label className="static-label">Mobile Number*</label>
              {errors?.login_mobile && (
                <div className="text-danger mt-1">
                  {errors.login_mobile.message}
                </div>
              )}
            </div>

            {loginMobileError && (
              <div className="text-danger mt-1">{loginMobileError}</div>
            )}

            {isOtpSentLogin && (
              <button
                type="button"
                className="btn btn-link mt-2"
                onClick={() => {
                  setIsOtpSentLogin(false);
                  setIsOtpVerifiedLogin(false);
                  setLoginOtp(["", "", "", "", "", ""]);
                  setTimerLogin(60);
                  setIsOtpExpiredLogin(false);
                  setValue("login_mobile", "");
                  setLoginOtpError("");
                  setLoginMobileError("");
                }}
              >
                Change Number
              </button>
            )}

            {!isOtpSentLogin && (
              <button
                type="button"
                className="btn btn-outline-primary w-100 mt-2"
                // disabled={!loginMobile || loginMobile.length !== 10}
                disabled={loading.sendLoginOtp}
                onClick={handleSendLoginOtp}
              >
                {/* Send OTP */}
                {loading.sendLoginOtp ? "Sending..." : "Send OTP"}
              </button>
            )}

            {isOtpSentLogin && !isOtpVerifiedLogin && (
              <div className="customer-otp-dotted-box">
                {!isOtpExpiredLogin && (
                  <>
                    <label className="customer-otp-label">Enter OTP</label>
                    <div className="customer-otp-slots">
                      {loginOtp.map((digit, index) => (
                        <div key={index} className="customer-otp-slot">
                          <input
                            id={`otp-login-${index}`}
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength="1"
                            value={digit}
                            className="customer-otp-input"
                            onChange={(e) =>
                              handleOtpChange(e.target.value, index, true)
                            }
                            onKeyDown={(e) => handleOtpKeyDown(e, index, true)}
                          />
                          <hr className="customer-otp-line" />
                        </div>
                      ))}
                    </div>

                    {loginOtpError && (
                      <div className="text-danger mt-2">{loginOtpError}</div>
                    )}

                    <button
                      type="button"
                      className="btn btn-success w-100 mt-3"
                      disabled={loading.verifyLoginOtp}
                      onClick={handleLoginVerifyOtp}
                    >
                      {/* Verify OTP */}
                      {loading.verifyLoginOtp ? "Verifying..." : "Verify OTP"}
                    </button>
                  </>
                )}

                {/* Resend OTP when timer expires - hides OTP input */}
                {isOtpExpiredLogin && (
                  <button
                    type="button"
                    className="btn btn-outline-primary w-100 mt-3"
                    onClick={handleSendLoginOtp}
                  >
                    Resend OTP
                  </button>
                )}

                {!isOtpExpiredLogin && (
                  <div className="text-center mt-2">
                    <small className="text-muted" key={timerLogin}>
                      Resend OTP in {timerLogin}s
                    </small>
                  </div>
                )}
              </div>
            )}

            {/* OTP Verified Message - No auto login */}
            {isOtpVerifiedLogin && (
              <div className="alert alert-success text-center mt-3">
                OTP Verified Successfully! Click on <strong>Login</strong> to
                continue.
              </div>
            )}
          </div>
        ) : (
          /* ====================== REGISTRATION SECTION ====================== */
          <div className="scroll-form-body">
            <div className="register-fields-container">
              {formStep === "register-step-1" ? (
                <div className="step-content">
                  {/* Name */}
                  <Form.Group className="customer-input-group">
                    <Form.Control
                      type="text"
                      placeholder=" "
                      {...register("name", {
                        required: "Full Name is required",
                        pattern: {
                          value: /^[A-Za-z\s]+$/,
                          message: "Name cannot contain numbers",
                        },
                      })}
                      className={classNames({ "is-invalid": errors?.name })}
                    />
                    <Form.Label>Full Name*</Form.Label>
                    {errors?.name && (
                      <span className="invalid-feedback d-block mb-4">
                        {errors.name.message}
                      </span>
                    )}
                  </Form.Group>

                  {/* Mobile */}
                  <Form.Group className="customer-input-group">
                    <div className="phone-wrapper">
                      <span className="country-code">+91</span>
                      <Form.Control
                        type="tel"
                        placeholder="Enter mobile number"
                        maxLength={10}
                        disabled={isOtpSentRegister || isOtpVerifiedRegister}
                        {...register("mobile_number", {
                          required: "Mobile number is required",
                          pattern: {
                            value: /^[0-9]{10}$/,
                            message: "Enter valid 10 digit mobile number",
                          },
                        })}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, "");
                          setMobileOtpErrorRegister(""); // 👈 add this
                        }}
                        className={classNames("phone-input", {
                          "is-invalid": errors?.mobile_number,
                        })}
                      />
                    </div>
                    <Form.Label className="static-label">
                      Mobile Number*
                    </Form.Label>
                    {errors?.mobile_number && (
                      <div className="text-danger mt-1">
                        {errors.mobile_number.message}
                      </div>
                    )}
                  </Form.Group>

                  {isOtpSentRegister && (
                    <button
                      type="button"
                      className="btn btn-link p-0 mt-1"
                      onClick={() => {
                        // ✅ Reset full OTP flow
                        setIsOtpSentRegister(false);
                        setIsOtpVerifiedRegister(false);
                        setRegisterOtp(["", "", "", "", "", ""]);
                        setTimerRegister(60);
                        setIsOtpExpiredRegister(false);

                        // ✅ Clear errors
                        setRegisterOtpError("");
                        setMobileOtpErrorRegister("");

                        // ✅ Clear mobile field
                        setValue("mobile_number", "");
                      }}
                    >
                      Change Number
                    </button>
                  )}

                  {!isOtpSentRegister && !isOtpVerifiedRegister && (
                    <button
                      type="button"
                      className="btn btn-outline-primary w-100 mt-2"
                      // disabled={!watchMobile || watchMobile.length !== 10}
                      disabled={loading.sendRegisterOtp}
                      onClick={handleSendRegisterOtp}
                    >
                      {/* Send OTP */}
                      {loading.sendRegisterOtp ? "Sending..." : "Send OTP"}
                    </button>
                  )}

                  {mobileOtpErrorRegister && (
                    <div className="text-danger mt-2">
                      {mobileOtpErrorRegister}
                    </div>
                  )}

                  {/* OTP Input */}
                  {isOtpSentRegister &&
                    !isOtpExpiredRegister &&
                    !isOtpVerifiedRegister && (
                      <div className="customer-otp-dotted-box">
                        <label className="customer-otp-label">Enter OTP</label>
                        <div className="customer-otp-slots">
                          {registerOtp.map((digit, index) => (
                            <div key={index} className="customer-otp-slot">
                              <input
                                id={`otp-register-${index}`}
                                type="tel"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength="1"
                                value={digit}
                                className="customer-otp-input"
                                onChange={(e) =>
                                  handleOtpChange(e.target.value, index, false)
                                }
                                onKeyDown={(e) =>
                                  handleOtpKeyDown(e, index, false)
                                }
                              />
                              <hr className="customer-otp-line" />
                            </div>
                          ))}
                        </div>

                        {registerOtpError && (
                          <div className="text-danger mt-1">
                            {registerOtpError}
                          </div>
                        )}

                        <button
                          type="button"
                          className="btn btn-success w-100 mt-3"
                          disabled={loading.verifyRegisterOtp}
                          onClick={handleVerifyRegisterOtp}
                        >
                          {/* Verify OTP */}
                          {loading.verifyRegisterOtp
                            ? "Verifying..."
                            : "Verify OTP"}
                        </button>

                        <div className="text-center mt-2">
                          <small className="text-muted" key={timerRegister}>
                            Resend OTP in {timerRegister}s
                          </small>
                        </div>
                      </div>
                    )}

                  {/* Resend OTP */}
                  {isOtpSentRegister &&
                    isOtpExpiredRegister &&
                    !isOtpVerifiedRegister && (
                      <button
                        type="button"
                        className="btn btn-outline-primary w-100 mt-2"
                        onClick={handleSendRegisterOtp}
                      >
                        Resend OTP
                      </button>
                    )}

                  {/* OTP Verified Button - Same as Customer */}
                  {isOtpVerifiedRegister && (
                    <div className="customer-otp-dotted-box text-center">
                      <button
                        type="button"
                        className="btn btn-success w-100 mt-3"
                        disabled
                      >
                        OTP Verified ✅
                      </button>
                    </div>
                  )}

                  <div className="customer-input-group">
                    <Form.Group className="customer-input-group">
                      <Form.Control
                        type="email"
                        placeholder=" "
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "Enter valid email address",
                          },
                        })}
                        className={classNames({
                          "is-invalid": errors?.email,
                        })}
                      />
                      <label className="static-label">Email Id*</label>

                      {errors?.email && (
                        <span className="invalid-feedback d-block mb-4">
                          {errors.email.message}
                        </span>
                      )}
                    </Form.Group>
                    <label className="static-label">Email Id*</label>
                  </div>

                  {/* ==================== Remaining Registration Fields ==================== */}
                  <div className="customer-input-group">
                    <Form.Control
                      type="text"
                      placeholder=" "
                      maxLength={12}
                      {...register("adhar_no", {
                        required: "Aadhar Card Number is required",
                        pattern: {
                          value: /^[0-9]{12}$/,
                          message: "Enter valid 12 digit Aadhar",
                        },
                      })}
                      onInput={(e) => {
                        e.target.value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 12);
                        // Cookies.remove("aadhaar_ref_id");

                        // setAadharOtpError("");
                      }}
                      className={classNames({ "is-invalid": errors?.adhar_no })}
                      // disabled={isAadharOtpVerified}
                      disabled={isAadharLocked}
                    />

                    <label>Aadhar Number*</label>

                    {errors?.adhar_no && (
                      <span className="invalid-feedback d-block mb-4">
                        {errors.adhar_no.message}
                      </span>
                    )}
                  </div>

                  {isAadharOtpSent && !isAadharOtpVerified && (
                    <button
                      type="button"
                      className="btn btn-link p-0 mt-1"
                      onClick={() => {
                        setIsAadharLocked(false);

                        setValue("adhar_no", "");

                        setIsAadharOtpSent(false);
                        setIsAadharOtpVerified(false);

                        setAadharOtp(["", "", "", "", "", ""]);

                        // setAadharOtpTimer(120);
                        setAadharOtpTimer(600);
                        setIsAadharOtpExpired(false);

                        setAadharOtpError("");

                        Cookies.remove("aadhaar_ref_id");
                      }}
                    >
                      Change Aadhaar Number
                    </button>
                  )}

                  {/* Send OTP Button */}
                  {!isAadharOtpSent && !isAadharOtpVerified && (
                    <button
                      type="button"
                      className="btn btn-outline-primary w-100 mt-2"
                      onClick={handleSendAadharOtp}
                      disabled={loadingAadharSendOtp}
                    >
                      {loadingAadharSendOtp ? "Sending..." : "Send Aadhaar OTP"}
                    </button>
                  )}

                  {/* Aadhaar Error Message */}
                  {aadharOtpError && !isAadharOtpSent && (
                    <div className="text-danger mt-2 text-center">
                      {aadharOtpError}
                    </div>
                  )}

                  {/* OTP Box */}
                  {isAadharOtpSent && !isAadharOtpVerified && (
                    <div className="customer-otp-dotted-box">
                      <label className="customer-otp-label">
                        Enter Aadhaar OTP
                      </label>

                      <div className="customer-otp-slots">
                        {aadharOtp.map((digit, index) => (
                          <div key={index} className="customer-otp-slot">
                            <input
                              id={`otp-aadhar-${index}`}
                              type="tel"
                              inputMode="numeric"
                              maxLength="1"
                              value={digit}
                              className="customer-otp-input"
                              onChange={(e) =>
                                handleAadharOtpChange(e.target.value, index)
                              }
                              onKeyDown={(e) =>
                                handleAadharOtpKeyDown(e, index)
                              }
                            />
                            <hr className="customer-otp-line" />
                          </div>
                        ))}
                      </div>

                      {aadharOtpError && (
                        <div className="text-danger text-center mt-2">
                          {aadharOtpError}
                        </div>
                      )}

                      <button
                        type="button"
                        className="btn btn-success w-100 mt-3"
                        onClick={handleVerifyAadharOtp}
                        disabled={loadingAadharVerifyOtp}
                      >
                        {loadingAadharVerifyOtp
                          ? "Verifying..."
                          : "Verify Aadhaar OTP"}
                      </button>

                      {!isAadharOtpExpired ? (
                        <div className="text-center mt-2">
                          <small className="text-muted">
                            Resend Aadhaar OTP in {formatTimer(aadharOtpTimer)}
                          </small>
                        </div>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-link w-100 mt-2"
                          onClick={async () => {
                            Cookies.remove("aadhaar_ref_id"); // remove old req_id

                            setAadharOtp(["", "", "", "", "", ""]);
                            setAadharOtpError("");
                            setIsAadharOtpExpired(false);
                            // setAadharOtpTimer(120);
                            setAadharOtpTimer(600);

                            await handleSendAadharOtp(); // sends OTP and stores new req_id
                          }}
                        >
                          Resend Aadhaar OTP
                        </button>
                      )}
                    </div>
                  )}

                  {/* Verified Message */}
                  {isAadharOtpVerified && (
                    <div className="customer-otp-dotted-box text-center">
                      <button
                        type="button"
                        className="btn btn-success w-100"
                        disabled
                      >
                        Aadhaar OTP Verified ✅
                      </button>
                    </div>
                  )}

                  <div className="customer-input-group">
                    <Controller
                      name="state_id"
                      control={control}
                      rules={{ required: "State is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={states}
                          styles={selectStyles}
                          placeholder=""
                          onChange={(val) => {
                            field.onChange(val);
                            setValue("district_id", null);
                            dispatch(AllDistrict({ state_id: val?.value }));
                          }}
                        />
                      )}
                    />
                    <label className="floating-label">State*</label>
                    {errors?.state_id && (
                      <span className="invalid-feedback d-block mb-4">
                        {errors.state_id.message}
                      </span>
                    )}
                  </div>

                  <div className="customer-input-group">
                    <Controller
                      name="district_id"
                      control={control}
                      rules={{ required: "District is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={districts}
                          styles={selectStyles}
                          placeholder=""
                          isDisabled={!selectedState}
                        />
                      )}
                    />
                    <label className="floating-label">District*</label>
                    {errors?.district_id && (
                      <span className="invalid-feedback d-block mb-4">
                        {errors.district_id.message}
                      </span>
                    )}
                  </div>

                  <Form.Group className="customer-input-group">
                    <Form.Control
                      type="text"
                      placeholder=" "
                      {...register("shop_name", {
                        required: "Shop Name is required",
                      })}
                      className={classNames({
                        "is-invalid": errors?.shop_name,
                      })}
                    />
                    <Form.Label>Shop/ShowRoom Name*</Form.Label>
                    {errors?.shop_name && (
                      <span className="invalid-feedback d-block mb-4">
                        {errors.shop_name.message}
                      </span>
                    )}
                  </Form.Group>

                  <Form.Group className="customer-input-group">
                    <Controller
                      name="category_id"
                      control={control}
                      rules={{ required: "Category is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          isMulti
                          options={categories}
                          styles={catSelectStyles}
                          placeholder=""
                          value={field.value || []}
                          onChange={(selected) => {
                            field.onChange(selected);

                            // reset sub category
                            setValue("service_category_id", []);
                          }}
                        />
                      )}
                    />
                    <label className="floating-label">Category*</label>
                    {errors?.category_id && (
                      <span className="invalid-feedback d-block mb-4">
                        {errors.category_id.message}
                      </span>
                    )}
                  </Form.Group>

                  <Form.Group className="customer-input-group">
                    <Controller
                      name="service_category_id"
                      control={control}
                      rules={{ required: "Sub Category is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          isMulti
                          options={subServiceCategories}
                          styles={catSelectStyles}
                          placeholder=""
                          value={field.value || []}
                          onChange={(selected) => field.onChange(selected)}
                          isDisabled={!selectedCategories?.length}
                        />
                      )}
                    />
                    <label className="floating-label">Sub Category*</label>
                    {errors?.service_category_id && (
                      <span className="invalid-feedback d-block mb-4">
                        {errors.service_category_id.message}
                      </span>
                    )}
                  </Form.Group>

                  <Form.Group className="customer-input-group">
                    <Form.Control
                      as="textarea"
                      placeholder=" "
                      {...register("description", {
                        required: "Description is required",
                        minLength: { value: 10, message: "Min 10 characters" },
                      })}
                      className={classNames({
                        "is-invalid": errors?.description,
                      })}
                    />
                    <Form.Label>Description*</Form.Label>
                    {errors?.description && (
                      <span className="invalid-feedback d-block mb-4">
                        {errors.description.message}
                      </span>
                    )}
                  </Form.Group>

                  {/* License Image */}
                  <Form.Group className="customer-input-group">
                    <Form.Control
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      {...register("licen_image", {
                        required: "Shopact License image required",
                        validate: (value) => {
                          if (!value || value.length === 0) return true;
                          const allowed = [
                            "image/jpeg",
                            "image/png",
                            "image/jpg",
                          ];
                          return (
                            allowed.includes(value[0].type) ||
                            "Only JPG, JPEG, PNG files allowed"
                          );
                        },
                      })}
                      className={classNames({
                        "is-invalid": errors?.licen_image,
                      })}
                    />
                    <label className="static-label">
                      Shopact Licence Image*
                    </label>
                    {errors?.licen_image && (
                      <span className="invalid-feedback d-block mb-4">
                        {errors.licen_image.message}
                      </span>
                    )}
                  </Form.Group>

                  {licenImageFile?.length > 0 && (
                    <div className="image-preview-container mt-2">
                      <img
                        src={URL.createObjectURL(licenImageFile[0])}
                        alt="License Preview"
                        style={{
                          width: "120px",
                          height: "120px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                        }}
                      />
                    </div>
                  )}

                  {/* Shop Image 1 */}
                  <Form.Group className="customer-input-group">
                    <Form.Control
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      {...register("shop_image", {
                        required: "Shop image required",
                        validate: (value) => {
                          if (!value || value.length === 0) return true;
                          const allowed = [
                            "image/jpeg",
                            "image/png",
                            "image/jpg",
                          ];
                          return (
                            allowed.includes(value[0].type) ||
                            "Only JPG, JPEG, PNG files allowed"
                          );
                        },
                      })}
                      className={classNames({
                        "is-invalid": errors?.shop_image,
                      })}
                    />
                    <label className="static-label">Shop Image 1*</label>
                    {errors?.shop_image && (
                      <span className="invalid-feedback d-block mb-4">
                        {errors.shop_image.message}
                      </span>
                    )}
                  </Form.Group>

                  {shopImageFile?.length > 0 && (
                    <div className="image-preview-container mt-2">
                      <img
                        src={URL.createObjectURL(shopImageFile[0])}
                        alt="Shop Preview"
                        style={{
                          width: "120px",
                          height: "120px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                        }}
                      />
                    </div>
                  )}

                  {/* Shop Image 2 */}
                  <Form.Group className="customer-input-group">
                    <Form.Control
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      {...register("shop_image2", {
                        validate: (value) => {
                          if (!value || value.length === 0) return true;
                          const allowed = [
                            "image/jpeg",
                            "image/png",
                            "image/jpg",
                          ];
                          return (
                            allowed.includes(value[0].type) ||
                            "Only JPG, JPEG, PNG files allowed"
                          );
                        },
                      })}
                      className={classNames({
                        "is-invalid": errors?.shop_image2,
                      })}
                    />
                    <label className="static-label">
                      Shop Image 2 (Optional)
                    </label>
                    {errors?.shop_image2 && (
                      <span className="invalid-feedback d-block mb-4">
                        {errors.shop_image2.message}
                      </span>
                    )}
                  </Form.Group>

                  {shopImage2File?.length > 0 && (
                    <div className="image-preview-container mt-2">
                      <img
                        src={URL.createObjectURL(shopImage2File[0])}
                        alt="Shop Preview 2"
                        style={{
                          width: "120px",
                          height: "120px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                        }}
                      />
                    </div>
                  )}

                  {/* Map */}
                  <Form.Group className="customer-input-group">
                    <Form.Control {...register("lat")} readOnly />
                    <label className="static-label">Latitude</label>
                  </Form.Group>

                  <Form.Group className="customer-input-group">
                    <Form.Control {...register("long")} readOnly />
                    <label className="static-label">Longitude</label>
                  </Form.Group>

                  <Form.Group className="customer-input-group">
                    <Form.Control
                      type="text"
                      placeholder=" "
                      ref={searchInputRef}
                    />
                    <Form.Label className="static-label">
                      Search Location
                    </Form.Label>
                  </Form.Group>

                  <div
                    ref={mapRef}
                    style={{
                      width: "100%",
                      height: "300px",
                      borderRadius: "10px",
                      marginTop: "10px",
                    }}
                  />

                  <Form.Group className="mt-3">
                    <Form.Check
                      type="checkbox"
                      id="receive_document"
                      label="Receive Documents via Email?"
                      {...register("receive_document")}
                    />
                  </Form.Group>

                  <div className="step-content mt-4">
                    <p className="docs-success-msg">
                      Documents have been signed successfully
                    </p>
                    <div className="container">
                      <div className="vendor-doc-card">
                        <span className="vendor-doc-title">MOU</span>
                        <button
                          type="button"
                          className="vendor-view-link"
                          onClick={handleViewMou}
                        >
                          View Document
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="step-content">
                  <p className="docs-success-msg">
                    Documents have been signed successfully
                  </p>
                  <div className="container">
                    <div className="vendor-doc-card">
                      <span className="vendor-doc-title">MOU</span>
                      <button
                        type="button"
                        className="vendor-view-link"
                        onClick={handleViewMou}
                      >
                        View Document
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Footer */}
        <div className="customer-footer-actions">
          <div className="footer-content-block">
            <Common_Login_Button
              text={
                !isRegistering
                  ? loading.login
                    ? "Logging in..."
                    : "Login"
                  : loading.register
                  ? "Registering..."
                  : "Register"
              }
              type={
                isRegistering && formStep === "register-step-1"
                  ? "button"
                  : "submit"
              }
              disabled={loading.login || loading.register}
              onClick={() => {
                if (!isRegistering) {
                  // LOGIN FLOW handled by submit already
                  return;
                }

                if (isRegistering && formStep === "register-step-1") {
                  handleSubmit(() => {
                    setFormStep("register-step-2");
                    document.querySelector(".scroll-form-body")?.scrollTo(0, 0);
                  })();
                }
              }}
            />

            <div className="customer-toggle-footer">
              <span>
                {!isRegistering
                  ? "Don't have an account?"
                  : "Already have an account?"}
              </span>
              <button
                type="button"
                className="customer-toggle-link"
                onClick={() => {
                  setIsRegistering(!isRegistering);
                  setFormStep("register-step-1");
                  if (isRegistering) {
                    setRegisterOtp(["", "", "", "", "", ""]);
                    setIsOtpSentRegister(false);
                    setIsOtpVerifiedRegister(false);
                    setIsOtpExpiredRegister(false);
                    setRegisterOtpError("");
                    setMobileOtpErrorRegister("");
                  } else {
                    setLoginOtp(["", "", "", "", "", ""]);
                    setIsOtpSentLogin(false);
                    setIsOtpVerifiedLogin(false);
                    setIsOtpExpiredLogin(false);
                    setLoginOtpError("");
                    setLoginMobileError("");
                  }
                }}
              >
                {!isRegistering ? "Create Account" : "Login Now"}
              </button>
            </div>
          </div>
        </div>
      </Form>

      <Account_Created_Modal
        showAccountModal={showAccountModal}
        handleAccountModalClose={() => setShowAccountModal(false)}
        text={modalText}
      />
    </div>
  );
};

export default Vendor_Login;
